document.addEventListener('DOMContentLoaded', function () {
    const faqAccordions = document.querySelectorAll('.twat-accordion-item.faqs-accordion');
    const rightAssets = document.querySelectorAll('.column-right .asset');

    if (faqAccordions.length > 0 && rightAssets.length > 0) {
      faqAccordions[0].classList.add('is-open');
      rightAssets[0].classList.add('is-open');
      faqAccordions[0].setAttribute('open', 'true');
    }

    faqAccordions.forEach((accordion, index) => {
      const summary = accordion.querySelector('.twat-accordion-item__title');

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        // Check if the clicked accordion is already open
        const isOpen = accordion.classList.contains('is-open');

        // Close all accordions
        faqAccordions.forEach(a => {
          a.classList.remove('is-open');
          a.removeAttribute('open');
        });

        // Open the clicked accordion if it was closed, or leave it closed if it was already open
        if (!isOpen) {
          accordion.setAttribute('open', 'true');
          accordion.classList.add('is-open');
          if (rightAssets[index]) {
            //rightAssets[index].classList.add('is-open');
          }
        }
      });
    });
  });